import { render, staticRenderFns } from "./ManageOwners.vue?vue&type=template&id=1acbba06&scoped=true"
import script from "./ManageOwners.vue?vue&type=script&lang=js"
export * from "./ManageOwners.vue?vue&type=script&lang=js"
import style0 from "./ManageOwners.vue?vue&type=style&index=0&id=1acbba06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acbba06",
  null
  
)

export default component.exports